import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiCompass, FiHome } from 'react-icons/fi';

export default function MobileRouteNotFound() {
  const location = useLocation();
  const path = location.pathname.replace(/^\/mobile\/?/, '') || 'home';
  return <div className="mobile-route-not-found"><span><FiCompass /></span><small>Mobile workspace</small><h2>This screen is not available</h2><p><strong>{path}</strong> does not match a POS screen that is enabled for this mobile workspace.</p><Link to="/mobile"><FiHome />Go to mobile dashboard</Link></div>;
}
